import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/jjfa/advantage1.png'
import _imports_1 from '@/assets/images/jjfa/advantage2.png'
import _imports_2 from '@/assets/images/jjfa/advantage3.png'
import _imports_3 from '@/assets/images/jjfa/advantage4.png'


const _hoisted_1 = { class: "education" }
const _hoisted_2 = { class: "fays" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "yycj" }
const _hoisted_5 = { class: "yycj-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "jiaoyu" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "jiaoyu" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "yyal"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "detail" }
const _hoisted_18 = {
  key: 1,
  style: {"height":"120rem","background":"#fff"}
}

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'MilitaryPolice',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref([])

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesList.value.length === 0) {
    selectCommonElement({ columnId: 4 }).then((res: any) => {
      casesList.value = [...res].filter(e => e.industry == 5).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0))
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.yycj_img11) {
    const yycj_img11: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img11.png');
    const yycj_img12: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img12.png');
    const yycj_img13: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img13.png');
    const yycj_img14: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img14.png');
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    loadUrl.value = { yycj_img11, yycj_img12, yycj_img13, yycj_img14, fays_bg }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title-font-style" }, "军警部队解决方案", -1)),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "VR技术在军事领域可以模拟真实战斗环境，使受训士兵“真正”进入形象逼真的战场，从而增强临场反应能力，减少人员损伤，大大提高训练质量。")
    ], -1)),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "subtitle" }, "方案优势", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("div", null, "直观全面地反映演习的动态和交互，环境逼真。")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_1 }),
          _createElementVNode("div", null, "降低了演习的时间、空间和地域的限制。")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_2 }),
          _createElementVNode("div", null, "使用方便，训练成本低。")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_3 }),
          _createElementVNode("div", null, "减少人员损伤，提升训练质量。")
        ])
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img11,
            class: "left-radius"
          }, null, 8, _hoisted_6),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, "虚拟战场", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("div", null, "武器装备操作训练", -1)),
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img12,
            class: "right-radius"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img13,
            class: "left-radius"
          }, null, 8, _hoisted_9),
          _cache[3] || (_cache[3] = _createElementVNode("div", null, "灾情救援仿真模拟", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, "单兵作战，远程协助作战演练", -1)),
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img14,
            class: "right-radius"
          }, null, 8, _hoisted_11)
        ])
      ])
    ]),
    (casesList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesList.value, (caseItem) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "yyal-content",
              key: caseItem.id
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (toOtherPath(`/case_detail?id=${caseItem.id}&pathName=解决方案,军警部队解决方案,应用案例`, ['解决方案', '军警部队解决方案', '应用案例']))
              }, [
                _createElementVNode("img", {
                  src: caseItem.ossPath
                }, null, 8, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(caseItem.title), 1),
                  _createElementVNode("div", null, _toDisplayString(caseItem.subTitle), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(caseItem.introduction), 1)
                ])
              ], 8, _hoisted_13)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18))
  ]))
}
}

})